import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../enums/modalId";
import { AppDispatch, RootState } from "../../../../redux/store/store";

/**
 * Centralized modal management for the Quick Review board page.
 *
 * Maps the redux `openedModalId` to the matching Oasis UI modal so the page
 * stays declarative. Register future Quick Review modals in the effect below.
 *
 * @returns Redux dispatch plus the current modal id and its metadata
 */
export const useQuickReviewModals = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );

  useEffect(() => {
    if (openedModalId === ModalId.QUICK_REVIEW_MODAL) {
      openModal(ModalId.QUICK_REVIEW_MODAL);
    }
    // Register additional Quick Review modals here as they are added.
  }, [openedModalId]);

  return {
    dispatch,
    openedModalId,
    metaData,
  };
};
